import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminService } from './admin.service';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

//const config: SocketIoConfig = { url: 'http://89.7.222.195:3000', options: {} };
const config: SocketIoConfig = { url: 'http://83.56.25.97:3000', options: {} };

@NgModule({
   declarations: [],
   imports: [
      CommonModule,
      SocketIoModule.forRoot(config)
   ],
   providers: [ AdminService ]
})
export class AdminModule { }
